import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserHelper } from '@app/helpers/user.helper';
@Component({
  selector: 'sure-routing-dialog',
  templateUrl: '../sharedTemplates/sure-routing-dialog.html',
})
export class SureRoutingDialog {
  constructor(public dialogRef: MatDialogRef<SureRoutingDialog>, public _UserHelper: UserHelper, private _Router: Router) {}
  yesClick(): void {
    this._Router.navigate(['/document']);
    this.dialogRef.close();
  }
}
